/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Field_CategoryInputs */

const en_agent_authorization_field_category = /** @type {(inputs: Agent_Authorization_Field_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category`)
};

const zh_agent_authorization_field_category = /** @type {(inputs: Agent_Authorization_Field_CategoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类`)
};

/**
* | output |
* | --- |
* | "Category" |
*
* @param {Agent_Authorization_Field_CategoryInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_field_category = /** @type {((inputs?: Agent_Authorization_Field_CategoryInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Field_CategoryInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_field_category(inputs)
	return zh_agent_authorization_field_category(inputs)
});
export { agent_authorization_field_category as "agent.authorization.field.category" }